<template>
    <divided-section 
        id="sek-about-section">
        <template v-slot:left-section>
            <container-title
                title-color="#141517"
                :title="'Saiba mais\nsobre nossos'"
                :sub-title="titles[currentTitle].subtitle" />
            
            <p class="sek-seguros-description">{{ titles[currentTitle].description }}</p>

            <circular-button
                class="sek-about-section-left-btn white--text">
                Saiba mais
            </circular-button>

            <carousel-3d
                @after-slide-change="updateItem"
                ref="mycarousel"
                :perspective="0"
                :width="250" 
                :height="410"
                :space="130"
                :inverse-scaling="100">
                <slide 
                    v-for="(item, i) in titles" 
                    :key="i"
                    :index="i"
                    :style="`background-image: url(${item.imgSrc})`">
                </slide>
            </carousel-3d>
        </template>
        <template v-slot:right-section>
            <container-title
                subtitle-color="#ff8800"
                :title="'Selecione \n um de nossos' "
                sub-title="seguros" />

            <div class="sek-seguros-items">
                <div 
                    v-for="(item, index) in seguroItems"
                    :key="index"
                    ripple
                    :class="{ selected: index === currentTitle }"
                    @click="currentTitle = index"
                    class="sek-seguros-items-item">
                    <div class="sek-seguros-items-item-button-wrapper">
                        <v-btn
                            text
                            large
                            color="black"
                            class="sek-seguros-items-item-button"
                            icon>
                            <v-icon color="white">{{ item.icon }}</v-icon>
                        </v-btn>
                    </div>

                    {{ item.content }}
                </div>
            </div>
        </template>
    </divided-section>
</template>

<script>
import DividedSection from "@/components/structure/DividedSection"
import ContainerTitle from "@/components/utils/ContainerTitle"
import CircularButton from "@/components/utils/CircularButton"
import { Carousel3d, Slide } from 'vue-carousel-3d';


export default {
    components: {
        "divided-section": DividedSection,
        "container-title": ContainerTitle,
        "circular-button": CircularButton,
        Carousel3d,
        Slide
    },
    data() {
        return {
            currentTitle: 0,
            titles: [
                {
                    imgSrc: require("@/assets/images/seguros/odonto.jpg"),
                    subtitle: "Seguros Saúde e Odontológicos",
                    description: "As melhores soluções de proteção à saúde para sua família,\nseus funcionários ou seu negócio. Planos de saúde das \nprincipais seguradoras do país."
                },
                {
                    imgSrc: require("@/assets/images/seguros/pessoas.jpg"),
                    subtitle: "Seguros Pessoas",
                    description: "Segurança para quem você mais ama. A forma mais inteligente e \npreventiva de garantir a proteção de todo planejamento \nfinanceiro de uma pessoa e sua família, em caso da ocorrência\nde alguma eventualidade"
                },
                {
                    imgSrc: require("@/assets/images/seguros/patrimoniais.jpg"),
                    subtitle: "Seguros Patrimoniais",
                    description: "Garantia de tranquilidade e conforto para o seu lar, com \nassistência 24h, pronta para atender emergências a qualquer\n horário do dia."
                },
                {
                    imgSrc: require("@/assets/images/seguros/financeiros.jpg"),
                    subtitle: "Seguros Riscos Financeiros",
                    description: "Garantia e cumprimento das obrigações contratuais, sejam \nelas públicas ou privadas"
                },
                {
                    imgSrc: require("@/assets/images/seguros/auto.jpg"),
                    subtitle: "Seguros Automóveis",
                    description: "A proteção ideal para seu veículo com todo suporte necessário \npara casos de roubo, furto, incêndio e perda total, além de \nassegurar a cobertura de danos materiais e corporais causados a terceiros"
                },
                {
                    imgSrc: require("@/assets/images/seguros/transportes.jpg"),
                    subtitle: "Seguros Transportes",
                    description: "A solução essencial para proteger bens e mercadorias em casos \nde prejuízos causados durante o transporte, seja por vias \nterrestres, aquáticas ou aéreas."
                },
                {
                    imgSrc: require("@/assets/images/seguros/financeiros.jpg"),
                    subtitle: "Seguros Responsabilidade Civil para Médico",
                    description: "A solução essencial para Médicos que buscam garantir sua \nproteção, com cobertura abrangente para defesa jurídica, \nacordos e indenizações."
                },
            ],
            seguroItems: [
                { id: 0, icon: "mdi-hospital-building", content: "Seguros Saúde e Odontológicos",  },
                { id: 1, icon: "mdi-account-multiple", content: "Seguro Pessoas",  },
                { id: 2, icon: "mdi-bank", content: "Seguros Patrimoniais",  },
                { id: 3, icon: "mdi-cash", content: "Seguros Riscos Financeiros",  },
                { id: 4, icon: "mdi-car-sports", content: "Seguros Automóveis",  },
                { id: 5, icon: "mdi-dropbox", content: "Seguros Transportes",  },
                { id: 6, icon: "mdi-badge-account", content: "Seguros Responsabilidade Civil para Médico",  },
            ]
        }
    },
    methods: {
        updateItem(val) {
            this.currentTitle = val
        }
    },
    watch: {
        currentTitle: function(val) {
            this.$refs.mycarousel.goSlide(val)
        }
    }
}
</script>

<style lang="scss">
#sek-about-section {
    height: 973px;

    .left-section {
        background-color: $c-white;
        padding-top: 75px;

        .sek-seguros-description {
            font-size: 18px;
            font-weight: 300;
            color: #707070;
            margin: 50px 0;
            white-space: pre-line;
        }

         .sek-about-section-left-btn {
            background-color: $c-secondary;
            width: 160px;
        }

        .carousel-3d-slide {
            border: 0 !important;
        }
    }

    .right-section {
        padding-top: 75px;
        overflow: visible;

        .sek-seguros-items {
            margin-top: 50px;
            transform: translateX(-47px);

            .sek-seguros-items-item {
                color: $c-white;
                font-weight: 300;
                display: flex;
                align-items: center;
                cursor: pointer;
                margin: 16px 0;

                &:hover, &.selected {
                    .sek-seguros-items-item-button-wrapper {
                        background: #ff8800;

                        .sek-seguros-items-item-button {
                            i {
                                color: #ff8800 !important;
                            }
                        }
                    }
                }

                .sek-seguros-items-item-button-wrapper {
                    background: $c-white;
                    height: 52px;
                    width: 52px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    margin-right: 15px;
                    transform: rotateZ(-16deg);
                    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);

                    .sek-seguros-items-item-button {
                        background: #141517 !important;
                    }
                }
                 
            }
        }
    }
}

@media screen and (max-width: 480px) {
    #sek-about-section {
        height: auto;

        .left-section {

        }

        .right-section {
            .sek-seguros-items {
                transform: translateX(0);
            }
        }
    }
}
</style>